import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { mockData } from '../mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center space-x-2 sm:space-x-3 flex-shrink-0">
            <img 
              src={mockData.company.logo} 
              alt={mockData.company.name}
              className="h-7 sm:h-8 w-auto"
            />
            <span className="text-lg sm:text-xl font-orbitron text-gray-900 whitespace-nowrap">4D Pocket</span>
          </div>

          {/* Navigation - Desktop Only (1024px+) */}
          <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8">
            <a href="#service" className="text-gray-700 hover:text-blue-500 transition-colors font-ui whitespace-nowrap">
              サービス
            </a>
            <a href="#case-study" className="text-gray-700 hover:text-blue-500 transition-colors font-ui whitespace-nowrap">
              制作事例
            </a>
            <a href="#process" className="text-gray-700 hover:text-blue-500 transition-colors font-ui whitespace-nowrap">
              制作の流れ
            </a>
            <a href="#faq" className="text-gray-700 hover:text-blue-500 transition-colors font-ui whitespace-nowrap">
              よくある質問
            </a>
            <Button 
              className="bg-gradient-to-r from-blue-500 to-green-500 hover:from-blue-600 hover:to-green-600 text-white px-6 font-cta whitespace-nowrap"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              お問い合わせ
            </Button>
          </nav>

          {/* Mobile/Tablet menu button */}
          <button
            className="lg:hidden flex-shrink-0"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="メニュー"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile/Tablet Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a href="#service" className="block px-3 py-2 text-gray-700 hover:text-blue-500">
                サービス
              </a>
              <a href="#case-study" className="block px-3 py-2 text-gray-700 hover:text-blue-500">
                制作事例
              </a>
              <a href="#process" className="block px-3 py-2 text-gray-700 hover:text-blue-500">
                制作の流れ
              </a>
              <a href="#faq" className="block px-3 py-2 text-gray-700 hover:text-blue-500">
                よくある質問
              </a>
              <Button 
                className="w-full bg-gradient-to-r from-blue-500 to-green-500 hover:from-blue-600 hover:to-green-600 text-white mt-2"
                onClick={() => {
                  setIsMenuOpen(false);
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                お問い合わせ
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;